import * as React from "react";
import { IdOrientation } from "../../../constants/IdOrientation";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { ButtonSecondaryAccentLarge } from "../../generic/common/ButtonSecondaryAccentLarge";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { Table } from "../../generic/table/Table";
import { TextLoca } from "../../generic/text/TextLoca";
var overviewTableHeaders = [IdLoca.rankingMenu_name, IdLoca.points];
export var ProjectOverview = function (_a) {
    var memberPointInfo = _a.memberPointInfo, onClose = _a.onClose, rankingRewards = _a.rankingRewards, loyaltyBoost = _a.loyaltyBoost;
    if (!memberPointInfo) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: IdStyles.DetailViewWrapper + " flex flex--guts" },
        React.createElement("div", { className: "flex flex--stacked flex--spaced " + IdStyles.DetailView },
            React.createElement("div", { className: "project-overview-table" },
                React.createElement(Table, { headers: getHeaders(), rows: getRows(memberPointInfo, rankingRewards, loyaltyBoost), rowClassName: IdStyles.TableRowProjects, tableContainerClassName: "flex flex--stacked" })),
            React.createElement("div", { className: "button-ribbon" },
                React.createElement(ButtonSecondaryAccentLarge, { onClick: onClose },
                    React.createElement(Icon, { icon: IdIcon.GreenArrowUpIcn, orientation: IdOrientation.Left, styleId: IdStyles.IconMedium }))))));
};
var getHeaders = function () {
    var headers = [];
    overviewTableHeaders.forEach(function (head, index) {
        var colClassName = head === utilLoca.get(IdLoca.rankingMenu_name) ? "td--project-overview-name" : "";
        headers.push(React.createElement(React.Fragment, { key: "th-" + index },
            React.createElement("div", { className: "td " + colClassName + " " + IdStyles.TextNormal },
                React.createElement(TextLoca, { id: head })),
            React.createElement("div", { className: "td__divider" })));
    });
    headers.push(React.createElement(React.Fragment, { key: "th-" + headers.length },
        React.createElement("div", { className: "td" },
            React.createElement(Icon, { icon: IdIcon.LoyaltyPointsIcn, styleId: IdStyles.IconSmall }))));
    return headers;
};
var getRows = function (memberPointInfo, rankingRewards, loyaltyBoost) {
    var rows = [];
    memberPointInfo.forEach(function (pointInfo, index) {
        var rowClassName = index < 3 ? IdStyles.TableRowProjectsGold : IdStyles.TableRowProjects;
        var baseAmount = rankingRewards && rankingRewards[index] && rankingRewards[index].lpAmount
            ? rankingRewards[index].lpAmount
            : 0;
        var loyalty = loyaltyBoost(baseAmount);
        rows.push(React.createElement("div", { className: rowClassName + " tr " + IdStyles.TextNormal, key: "p-" + pointInfo.playerId },
            React.createElement("div", { className: "td td--project-overview-name" }, pointInfo.name),
            React.createElement("div", { className: "td__divider" }),
            React.createElement("div", { className: "td" },
                React.createElement(NumberFormat, { amount: pointInfo.amount || 0 })),
            React.createElement("div", { className: "td__divider" }),
            React.createElement("div", { className: "td" },
                React.createElement(NumberFormat, { amount: loyalty }))));
    });
    return rows;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/ProjectOverview.tsx
// module id = 2597
// module chunks = 3